import Layout from '@/layout'
const integralRouter = {
    component: Layout,
    path: '/integral',
    name: '积分管理',
    redirect: 'integral',
    meta: {
        title: '积分管理',
        icon: ''
    },
    children: [
        {
            path: '/integral/integral',
            name: 'integral',
            meta: { title: "积分管理" },
            component: () => import('../views/integral/integral/list.vue')
        },
        {
            path: "/integral/matter",
            name: "matter",
            meta: { title: "积分事项管理" },
            component: () => import('../views/integral/matter/list.vue')
        },
    ]
}
export default integralRouter
